var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    {
      ref: "AddLeaveRequestForm",
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.formSubmitted($event)
        },
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.formSubmitted($event)
            },
          },
        },
        [
          _c(
            "b-row",
            [
              _vm.IsAdmin()
                ? _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Employee*",
                            "label-for": "employee",
                          },
                        },
                        [
                          _c("validation-provider", {
                            attrs: { name: "Employee", rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "employee",
                                          options: _vm.formattedEmployeeOptions,
                                          "value-field": "id",
                                          "text-field": "fullName",
                                          state:
                                            errors.length > 0 ? false : null,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.newRequest.employeeId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.newRequest,
                                              "employeeId",
                                              $$v
                                            )
                                          },
                                          expression: "newRequest.employeeId",
                                        },
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(errors[0]))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1142707135
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Leave Type*",
                        "label-for": "leave_type",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: { name: "Leave Type", rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.fetchLeaveType,
                                    state: errors.length > 0 ? false : null,
                                    required: "",
                                    "value-field": "leaveTypeId",
                                    "text-field": "title",
                                  },
                                  model: {
                                    value: _vm.newRequest.leaveTypeId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newRequest,
                                        "leaveTypeId",
                                        $$v
                                      )
                                    },
                                    expression: "newRequest.leaveTypeId",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Start Date*",
                        "label-for": "start_date",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: "startDate",
                          vid: "startDate",
                          rules: "required",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "start_date",
                                    type: "date",
                                    placeholder: "Choose a date",
                                    local: "en",
                                    state: errors.length > 0 ? false : null,
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.newRequest.startDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newRequest, "startDate", $$v)
                                    },
                                    expression: "newRequest.startDate",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.newRequest.leaveDurationType !== "HalfDay"
                ? _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "End Date*",
                            "label-for": "return_date",
                          },
                        },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "return_date",
                              vid: "returnDate",
                              rules: "required",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "return_date",
                                          placeholder: "Choose a date",
                                          type: "date",
                                          local: "en",
                                          state:
                                            errors.length > 0 ? false : null,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.newRequest.returnDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.newRequest,
                                              "returnDate",
                                              $$v
                                            )
                                          },
                                          expression: "newRequest.returnDate",
                                        },
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(errors[0]))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              866031561
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "No. of Days",
                        "label-for": "no_of_days",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "no_of_days", readonly: "" },
                        model: {
                          value: _vm.leaveDays,
                          callback: function ($$v) {
                            _vm.leaveDays = $$v
                          },
                          expression: "leaveDays",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Leave Duration Type*",
                        "label-for": "leaveDurationType",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: "Leave Duration Type",
                          vid: "leaveDurationType",
                          rules: "required",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.leaveDurationTypeOptions,
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.newRequest.leaveDurationType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newRequest,
                                        "leaveDurationType",
                                        $$v
                                      )
                                    },
                                    expression: "newRequest.leaveDurationType",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Upload File",
                        "label-for": "upload_file",
                      },
                    },
                    [
                      _c("b-form-file", {
                        attrs: {
                          placeholder: "Choose a file or drop it here...",
                          "drop-placeholder": "Drop file here...",
                        },
                        model: {
                          value: _vm.newRequest.file,
                          callback: function ($$v) {
                            _vm.$set(_vm.newRequest, "file", $$v)
                          },
                          expression: "newRequest.file",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Notes*", "label-for": "notes" } },
                    [
                      _c("validation-provider", {
                        attrs: { name: "notes", rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-textarea", {
                                  attrs: {
                                    id: "notes",
                                    placeholder: "notes",
                                    rows: "1",
                                  },
                                  model: {
                                    value: _vm.newRequest.notes,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newRequest, "notes", $$v)
                                    },
                                    expression: "newRequest.notes",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Approving Manager*",
                        "label-for": "approving_manager",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: "Approving Manager",
                          vid: "approving_manager",
                          rules: "required",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.formattedEmployeeOptions,
                                    "value-field": "id",
                                    "text-field": "fullName",
                                    state: errors.length > 0 ? false : null,
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.newRequest.managerId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newRequest, "managerId", $$v)
                                    },
                                    expression: "newRequest.managerId",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-between",
                  attrs: { md: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        type: "button",
                        variant: "primary",
                        disabled: _vm.invalid,
                      },
                      on: { click: _vm.formSubmitted },
                    },
                    [_vm._v("Save ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }